import type { CardHooks } from "./registry";

/** Handle Bash — Stun keyword on both attack and defend. Engine respects keyword arrays directly. */
export const handleBash: CardHooks = {
  // No additional logic beyond keyword presence — the keyword arrays are honored.
};
